import {
  CC_PROFESIONAL,
  CC_UNPROFESIONAL,
  CE_BASIC,
  CE_EXPERIENCED,
  CE_INFORMED,
  CLA_NO,
  CLA_YES,
  CP_GROW,
  CP_PROTECTION,
} from '../constants/codeListsItems'
import { HORIZONTE_VALUE_MAX, RISK_VALUE_MAX } from '../constants/codeLists'

/**
 * V DB existují obě varianty kódu kategorie: CC_PROFESIONAL (původní překlep, část CP)
 * i CC_PROFESSIONAL (číselník po migraci V55, všichni klienti). Porovnáváme sjednoceně.
 */
const normalizeCategory = (category: string | null) =>
  category ? category.replace('PROFESIONAL', 'PROFESSIONAL') : null

export const categorySecValidation = (clientCategory: string | null, securityCategory: string | null) => {
  if (clientCategory === null || securityCategory === null) return false

  const client = normalizeCategory(clientCategory)
  const security = normalizeCategory(securityCategory)
  if (client === normalizeCategory(CC_UNPROFESIONAL) && security === normalizeCategory(CC_PROFESIONAL)) return true
  else return false
}

export const skillAndExperienceSecValidation = (clientSkill: string | null, securitySkill: string | null) => {
  if (clientSkill === null || securitySkill === null) return false

  if (clientSkill === CE_EXPERIENCED) return false
  else if (clientSkill === CE_INFORMED) {
    if (securitySkill == CE_EXPERIENCED) return true
    else return false
  } else if (clientSkill === CE_BASIC) {
    if (securitySkill === CE_BASIC) return false
    else return true
  } else return false
}

export const preferenceSecValidation = (clientPrefence: string | null, securityPreference: string | null) => {
  if (clientPrefence === null || securityPreference === null) return false

  if (clientPrefence === CP_PROTECTION && securityPreference === CP_GROW) return true
  else return false
}

export const lossAbilitySecValidation = (clientLossAbility: string | null, securityLossAbility: string | null) => {
  if (clientLossAbility === null || securityLossAbility === null) return false

  if (clientLossAbility === CLA_NO && securityLossAbility === CLA_YES) return true
  else return false
}

/**
 * Klient má aktualizovaný investiční dotazník, pokud má vyplněné datum platnosti
 * a to datum ještě neuplynulo (porovnání jen na dny, bez času).
 */
export const hasValidInvestmentQuestionnaire = (validTo: Date | string | null | undefined) => {
  if (!validTo) return false
  const validToDate = new Date(validTo)
  if (isNaN(validToDate.getTime())) return false
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  validToDate.setHours(0, 0, 0, 0)
  return validToDate >= today
}

/** Horizont CP delší než horizont klienta = rozpor (true). Bez objemu, čisté porovnání Klient vs. CP. */
export const horizonteSecValidation = (clientHorizonte: string | number | null, securityHorizonte: number | null) => {
  if (clientHorizonte === null || clientHorizonte === undefined || clientHorizonte === '') return false
  const secValue = securityHorizonte ? securityHorizonte : HORIZONTE_VALUE_MAX
  return secValue > Number(clientHorizonte)
}

/** Rizikovost CP vyšší než rizikový profil klienta = rozpor (true). */
export const riskSecValidation = (clientRiskProfile: number | null, securityRisk: number | null) => {
  if (clientRiskProfile === null || clientRiskProfile === undefined) return false
  const secValue = securityRisk ? securityRisk : RISK_VALUE_MAX
  return secValue > clientRiskProfile
}
